import Box from "@mui/material/Box";
import { Stack, Typography } from "@mui/material";
import TransferTokenOwnershipProposalTable from "./tables/TranferVestingBeneficiary";
import ProposalTabs from "../../../shared/ProposalTabs";
import ProceedTable from "./tables/ProceedTable";

export default function TransferTokenOwnershipProposalPage() {
  return (
    <Box>
      <Stack
        direction="row"
        sx={{ width: "100%", marginBottom: 2, alignItems: "center" }}
      >
        <Typography variant="h5" sx={{ flexGrow: 1 }}>
          Transfer Token Ownership Proposal
        </Typography>
      </Stack>
      <ProposalTabs
        processingTab={<TransferTokenOwnershipProposalTable />}
        proceedTab={<ProceedTable />}
      />
    </Box>
  );
}
